import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import loading from "assets/images/infinite-blue.svg";
import { unauthorizedRoutes } from "./mapping";
import {
  addTawkScript,
  addGoogleTagManagerScript,
  addHubspotScript,
  addLinkedInScript,
  addLiveChatScript,
  addClarityScript,
  removeTawkScript,
  removeGoogleTagManagerScript,
  removeHubspotScript,
  removeLinkedInScript,
  removeClarityScript,
  removeApolloScript,
  addApolloScript
} from "scripts";
import { Helmet } from "react-helmet";

function Unauthorized() {
  return (
    <Suspense
      fallback={
        <div className="d-flex align-items-center justify-content-center" style={{ height: "100vh" }}>
          <img src={loading} alt="loading" width="100px" />
        </div>
      }
    >
      <Switch>
        {unauthorizedRoutes.map(i => (
          <Route
            key={i.path}
            exact={i.exact}
            path={i.path}
            render={props => {
              // addLiveChatScript();
              const pathname = props.location.pathname;
              if (pathname.startsWith("/useroptout/") || pathname.startsWith("/optout/")) {
                removeClarityScript();
              } else {
                const clarityRoutes = ["/", "/signup", "/verification", "/signup-verify", "/user-welcome", "/mfa-email-list"];
                if (clarityRoutes.includes(i.path)) {
                  addClarityScript(true);
                } else {
                  removeClarityScript();
                }
              }

              // Apollo script management for /signup route
              if (i.path === "/signup") {
                addApolloScript();
              } else {
                removeApolloScript();
              }

              if (["/signup", "/signup-welcome", "/signup-mobile", "/signup-verify", "/user-welcome"].includes(i.path)) {
                // addHubspotScript();
                // addTawkScript(false);
                addGoogleTagManagerScript();
                addLinkedInScript();
              } else {
                // removeHubspotScript();
                // if (["/", "/verification", "/mfa-email-list"].includes(i.path)) {
                //   addTawkScript(false);
                // }
                removeGoogleTagManagerScript();
                removeLinkedInScript();
                // removeTawkScript();
              }
              removeTawkScript();

              !i?.stopPreview ? (document.title = `${i.title ? `${i.title} | ` : ""}Guni Online and Bulk SMS Gateway`) : null;
              return (
                <>
                  {i?.stopPreview && (
                    <Helmet>
                      <title> </title>
                      <meta property="og:url" content="https://app.gunisms.com.au/nonexistent-url" />
                    </Helmet>
                  )}
                  <i.Component {...props} />
                </>
              );
            }}
          />
        ))}
      </Switch>
    </Suspense>
  );
}

export default Unauthorized;
